import React, { useState, useEffect } from 'react';
import { Form, Select, Row, Col, Button, Modal, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import EditableTable from 'src/components/common/editableTable';
import newAlert from 'src/components/newAlert';
import { PlusCircleOutlined } from '@ant-design/icons';
import { AddNewBurtgel } from 'src/components/undsenHurungu/addNewBurtgel';
import { ColumnsBurtgelEdit, EditSum } from './dataStructure/data';
import { start_loading, end_loading } from '../../../core/actions/loader';
import { customConfirm } from 'src/components/common/confirmModal';

const { Option } = Select;
const EditJournal = ({ onCancel = {}, visible }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const data_date = useSelector((state) => state.data_date);
  const socket = useSelector((state) => state.socket);
  const [tableDataTotal, setTableDataTotal] = useState({});
  const [saved, seTsaved] = useState(true);

  const [tableDataList, setTableDataList] = useState([]);
  const [tableDataInfo, setTableDataInfo] = useState({});

  const [burtgelOpenDialog, setBurtgelOpenDialog] = useState(false);
  const [burtgelUpdate, setBurtgelUpdate] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  const select_data = () => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        console.log(data);
        setTableDataTotal(data?.content?.total_list);
        setTableDataList(data?.content?.result_list);
        setTableDataInfo(data?.content?.result_json);
      } else {
        newAlert({ type: 'error', msg: 'Системд алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });
    const { month } = data_date;
    const search = {
      // dans: hurunguData.dans_dugaar,
      // hurungu: hurunguData.hurungu_id,
    };
    socket.emit('request_in', {
      channel: 'ts001_05_view',
      content: {
        action_type: 'sanhuu_journal_edit',
        month,
        search,
      },
    });
    dispatch(start_loading({}));
  };
  useEffect(() => {
    if (visible) {
      select_data();
    }
  }, [visible]);
  const clear = (inputString) => {
    const stringWithoutCommas = String(inputString).replace(/,/g, '');
    const numberValue = parseFloat(stringWithoutCommas);
    return numberValue;
  };

  const sumBurt = () => {
    const temp_sum = {
      deb: 0,
      cred: 0,
    };
    tableDataList.forEach((item) => {
      temp_sum.deb += clear(item.deb);
      temp_sum.cred += clear(item.cred);
    });
    setTableDataTotal({ ...temp_sum });
  };
  const closeModal = () => {
    form.resetFields();
    setTableDataList([]);
    setTableDataInfo({});
    setTableDataTotal({});
    setSelectedValues([]);
    onCancel();
  };

  const handleSave = () => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');
      if (data.status === '0') {
        newAlert({ type: 'success', msg: data.message });
        seTsaved(true);
      } else {
        newAlert({ type: 'error', msg: data.message });
      }
      // closeModal();
      dispatch(end_loading({}));
    });

    const { month } = data_date;
    socket.emit('request_in', {
      channel: 'ts001_05_modify',
      content: {
        action_type: 'sanhuu_journal_edit_save',
        json_array: { ...tableDataList },
        month: month,
      },
    });
    dispatch(start_loading({}));
  };

  const onFinish = () => {
    customConfirm({
      title: 'Хадгалах уу?',
      onOk: () => {
        if (
          Number(tableDataTotal.deb.toFixed(2)) ===
          Number(tableDataTotal.cred.toFixed(2))
        ) {
          handleSave();
        } else {
          newAlert({ type: 'warning', msg: 'Дебет, Кредит тулаагүй байна !!' });
        }
      },
    });
  };

  const geTvalue = (value) => {
    setTableDataList([...value]);
    seTsaved(false);
  };
  useEffect(() => {
    if (visible && tableDataList) sumBurt();
  }, [tableDataList]);

  const layout = {
    labelCol: {
      xs: { span: 5 },
      sm: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 19 },
      sm: { span: 19 },
    },
  };
  useEffect(() => {
    if (burtgelUpdate && !burtgelOpenDialog) {
      select_data();
      setBurtgelUpdate(false);
    }
  }, [burtgelOpenDialog]);

  const handleAddButtonClick = () => {
    const temp_row = {
      key: null,
      dans_id: null,
      dans_dugaar: null,
      ded_agilal: 0.0,
      deb: 0.0,
      cred: 0.0,
    };

    const new_rows = selectedValues
      .map((selectedId) => {
        const dansInfo = tableDataInfo?.dans_list.find(
          (info) => info?.dans_id === selectedId,
        );
        if (dansInfo) {
          return {
            ...temp_row,
            key: dansInfo.dans_id + '_' + (tableDataList.length + 1),
            dans_id: dansInfo.dans_id,
            dans_dugaar: dansInfo.dans_dugaar,
            dans_ner: dansInfo.dans_ner,
            ded_agilal: dansInfo.ded_agilal,
          };
        }
        return null; // or handle if not found
      })
      .filter((row) => row !== null); // Remove null entries if any
    setTableDataList([...tableDataList, ...new_rows]);
    setSelectedValues([]);
    seTsaved(false);
  };
  const deleteRow = (row) => {
    console.log(tableDataList);
    const updatedResultList = tableDataList.filter(
      (item) => item.key !== row.key,
    );
    setTableDataList([...updatedResultList]);
    seTsaved(false);
  };

  return (
    <Modal
      className="custom-modal"
      title="Журнал ноорог"
      open={visible}
      width="100%"
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <div className="dans-medeelel-container">
        <AddNewBurtgel
          openDialog={burtgelOpenDialog}
          setOpenDialog={setBurtgelOpenDialog}
        />
        <Form
          form={form}
          onFinish={onFinish}
          className="register-form"
          {...layout}
          size="small"
        >
          <Form.Item
            name="hurungu_turul"
            // label="нэмэх"
            labelAlign="left"
          >
            <Select
              size="small"
              placeholder="Сонгох"
              allowClear
              mode="multiple"
              value={selectedValues}
              onChange={setSelectedValues}
              style={{ width: '60%', fontSize: 13 }}
              showSearch
              maxTagCount={1}
              maxTagPlaceholder={(omittedValues) => (
                <Tooltip
                  overlayStyle={{ pointerEvents: 'none' }}
                  title={omittedValues.map(({ label }) => label).join(', ')}
                >
                  <span>Сонгосон</span>
                </Tooltip>
              )}
              filterOption={(input, option) =>
                (option?.children ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {tableDataInfo?.dans_list?.map((dansInfo) => (
                <Option key={dansInfo?.dans_id} value={dansInfo?.dans_id}>
                  {dansInfo?.dans_dugaar + ' ' + dansInfo?.dans_ner}
                </Option>
              ))}
            </Select>
            <Button
              className="add-btn"
              type="primary"
              size="small"
              icon={<PlusCircleOutlined />}
              onClick={handleAddButtonClick}
            >
              Нэмэх
            </Button>
          </Form.Item>
          <Form.Item noStyle shouldUpdate>
            {visible && tableDataList && (
              <EditableTable
                dataSource={tableDataList}
                columns={ColumnsBurtgelEdit({ deleteRow })}
                geTvalue={geTvalue}
                pagination={{
                  pageSize: 20,
                }}
                customize={() => <EditSum data={tableDataTotal} />}
                scroll={{
                  y: 'calc(100vh - 430px)',
                }}
              />
            )}
          </Form.Item>
          <Row style={{ marginTop: 10 }}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button
                onClick={() => {
                  if (saved) {
                    closeModal();
                  } else {
                    customConfirm({
                      title: 'Хадгалаагүй байна. Буцахыг зөвшөөрөх үү?',
                      onOk: () => {
                        closeModal();
                      },
                    });
                  }
                }}
                className="cancel-btn"
                type="primary"
                shape="round"
              >
                Буцах
              </Button>
              <Button
                className="confirm-btn ml-5"
                type="primary"
                shape="round"
                htmlType="submit"
              >
                Хадгалах
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default EditJournal;
